<div class="filterStudent">
  <label id="radio-group-label">Show Students</label>
  
  <mat-radio-group
    aria-labelledby="radio-group-label"
    class="radio-group"
    color="primary"
    (change)="filterStudents($event)"
    >
    <br><br>
    <mat-radio-button class="radio-button" [checked]="getCheckedValue(1)" [value]="1">
    All
    </mat-radio-button>
    <br>
    <mat-radio-button class="radio-button" [checked]="getCheckedValue(2)" [value]="2">
      Needs Attention
    </mat-radio-button>
  </mat-radio-group>
</div>


